<template>
    <div class="admin-dashboard-container container-fluid p-0" id="marker-dashboard-page">
        <div class="row my-3">
            <div class="col-12 d-flex justify-content-between dashboard-grid-padding">
                <h2>Dashboard</h2>
                <div class="d-flex justify-content-end">
                    <el-dropdown class="w-100">
                        <el-button style="color: green" size="small" @click="handleActionButtonClick">
                            Action
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="clearModelCache()">
                                <span>Clear Model Cache</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="addLibertyProducts()">
                                <span>Add Liberty Products</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="updateLibertyProducts()">
                                <span>Update Tenant Tokens</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" class="ml-2" ref="refreshBtn" :disabled="btnDisable" type="primary" @click="refreshData">
                        Refresh All Data
                        <i class="fas fa-sync blue-refresh-btn-icon"></i>
                    </el-button>
                </div>
            </div>
        </div>
        <div class="row cols-container cols-1">
            <div class="col-12 column-1"></div>
        </div>
        <div class="row cols-container cols-2">
            <div class="col-6 column-1"></div>
            <div class="col-6 column-2"></div>
        </div>
        <div class="row cols-container cols-3">
            <div class="col-4 column-1"></div>
            <div class="col-4 column-2"></div>
            <div class="col-4 column-3"></div>
        </div>
        <div class="row cols-container cols-4">
            <div class="col-3 column-1"></div>
            <div class="col-3 column-2"></div>
            <div class="col-3 column-3"></div>
            <div class="col-3 column-4"></div>
        </div>
        <div class="row my-1">
            <div class="dashboard-grid-padding card-columns w-100">
                <div class="dashboard-card-margin card" id="dashboard-widget-filter">
                    <div class="el-card card-funnel blue-widget pb-2 is-always-shadow">
                        <div class="el-card__header row mx-0">
                            <div class="col-auto px-0">
                                <h3 class="text-capitalize mt-1">Date Range</h3>
                            </div>
                            <div class="col px-0">
                                <date-range-picker
                                    name="picker"
                                    label="Range Picker"
                                    v-model="dateRange"
                                ></date-range-picker>
                            </div>
                        </div>

                        <div class="el-card__body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card mb-1 mix-blend-mode-multiple">
                                        <div class="px-2">
                                            <div class="w-100">
                                                <dashboard-settled ref="total-income" :token="token" v-cloak
                                                                :date-scope="dateRange" :team-id="getTeamId"
                                                                :broker-id="getBrokerId" height="40"></dashboard-settled>
                                            </div>
                                        </div>

                                        <div class="card-footer border text-center py-3">
                                            <div class="row">
                                                <div class="col px-2">
                                                    <div class="text-muted small mb-1">Settled</div>
                                                    <strong class="text-big">{{ animatedSettledDeals }}</strong>
                                                </div>
                                                <div v-if="!hideTenantFinancials" class="col px-2">
                                                    <div class="text-muted small mb-1">NAF</div>
                                                    <strong class="text-big">${{ animatedNAF }}</strong>
                                                </div>
                                                <div v-if="!hideTenantFinancials" class="col px-2">
                                                    <div class="text-muted small mb-1">Income Ex GST</div>
                                                    <strong class="text-big">${{ animatedCommissions }}</strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="metrics.insurance_deals"
                                            class="card-footer border border-top-0 text-center py-3">
                                            <div class="row">
                                                <div class="col px-2">
                                                    <div class="text-muted small mb-1">Insurance Only</div>
                                                    <strong class="text-big">{{animatedInsuranceOnlyDeals}}</strong>
                                                </div>
                                                <div v-if="!hideTenantFinancials && metrics.naf" class="col px-2"></div>
                                                <div v-if="!hideTenantFinancials" class="col px-2">
                                                    <div class="text-muted small mb-1">Income Ex GST</div>
                                                    <strong class="text-big">${{animatedInsuranceOnlyCommissions}}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dashboard-card-margin card" id="dashboard-leaderboard" v-if="canViewLeaderboards">
                    <dashboard-broker-settlements
                        ref="broker-settlements"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                    ></dashboard-broker-settlements>
                </div>
                <div class="dashboard-card-margin card" id="dashboard-lender-leaderboards">
                    <dashboard-lender-leaderboards
                        ref="lender-leadboards"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                    >
                        <div class="d-flex justify-content-between" slot="header">
                            <h3 class="text-capitalize mt-1">Lender Leaderboard</h3>
                        </div>
                    </dashboard-lender-leaderboards>
                </div>
                <!-- <div class="dashboard-card-margin card" id="dashboard-team-leaderboards" v-if="Ambition.Globals.tenant.user.teams.length > 1">
                  <dashboard-team-leaderboards ref="team-leadboards" :token="token" v-cloak :date-scope="dateRange" :broker-id="getBrokerId"></dashboard-team-leaderboards>
                </div> -->
                <div class="dashboard-card-margin card" id="funnel-container">
                    <dashboard-pipeline
                        ref="pipeline"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                        :allow-data-view="canAdvancedSearch"
                    >
                        <div class="d-flex justify-content-between" slot="header">
                            <h3 class="text-capitalize mt-1">Activity</h3>
                        </div>
                    </dashboard-pipeline>
                </div>
                <div class="dashboard-card-margin card" id="dashboard-total-income">
                    <dashboard-total-income
                        ref="total-income"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                    >
                        <div class="d-flex justify-content-between" slot="header">
                            <h3 class="text-capitalize mt-1">Total Income</h3>
                        </div>
                    </dashboard-total-income>
                </div>
                <!-- <div class="dashboard-card-margin card" id="dashboard-lender-submissions">
                  <dashboard-lender-submissions ref="lender-submissions" :token="token" v-cloak :date-scope="dateRange" :team-id="getTeamId" :broker-id="getBrokerId"></dashboard-lender-submissions>
                </div> -->
                <div class="dashboard-card-margin card" id="dashboard-lead-to-settle">
                    <dashboard-lead-to-settlement
                        ref="lead-to-settlement"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                        :allowViewDetail="!!canViewAllApplications"
                    >
                        <div class="d-flex justify-content-between" slot="header">
                            <h3 class="text-capitalize mt-1">Lead to Settlement</h3>
                        </div>
                    </dashboard-lead-to-settlement>
                </div>
                <div class="dashboard-card-margin card" id="dashboard-avg-income">
                    <dashboard-avg-income
                        ref="avgIncome"
                        :token="token"
                        v-cloak
                        :date-scope="dateRange"
                        :team-id="getTeamId"
                        :broker-id="getBrokerId"
                    >
                        <div class="d-flex justify-content-between" slot="header">
                            <h3 class="text-capitalize mt-1">Average Net Income Per Deal</h3>
                        </div>
                    </dashboard-avg-income>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateRangePicker from '@tenant/ambition/components/form-elements/DateRangePicker';
import DashboardCloseBy from "@tenant/ambition/dashboard/DashboardCloseBy";
import DashboardPipeline from "@tenant/ambition/dashboard/DashboardPipeline";
import DashboardMonthlyLeads from "@tenant/ambition/dashboard/DashboardMonthlyLeads";
import DashboardTotalIncome from "@tenant/ambition/dashboard/DashboardTotalIncome";
import DashboardBrokerSettlements from "@tenant/ambition/dashboard/DashboardBrokerSettlements";
import DashboardLenderSubmissions from "@tenant/ambition/dashboard/DashboardLenderSubmissions";
import DashboardAvgIncome from "@tenant/ambition/dashboard/DashboardAvgIncome";
import DashboardSettled from "@tenant/ambition/dashboard/DashboardSettled";
import DashboardLenderLeaderboards from "@tenant/ambition/dashboard/DashboardLenderLeaderboards";
import DashboardTeamLeaderboards from "@tenant/ambition/dashboard/DashboardTeamLeaderboards";
import DashboardLeadToSettlement from "@tenant/ambition/dashboard/DashboardLeadToSettlement";
import Multiselect from 'vue-multiselect'
import mixinPermissions from '@tenant/ambition/permissions/permissions';

export default {
    name: 'DashboardLayout',
    mixins: [mixinPermissions],
    props: ["token", "isBroker", "isAdmin", "canViewAllApplications", "canAdvancedSearch", "canViewLeaderboards", "hideTenantFinancials", "permissions", "dropDownOptions"],
    components: {
        "dashboard-closed-by": DashboardCloseBy,
        "dashboard-total-income": DashboardTotalIncome,
        "dashboard-broker-settlements": DashboardBrokerSettlements,
        "dashboard-lender-submissions": DashboardLenderSubmissions,
        "dashboard-lender-leaderboards": DashboardLenderLeaderboards,
        "dashboard-team-leaderboards": DashboardTeamLeaderboards,
        "dashboard-avg-income": DashboardAvgIncome,
        "dashboard-settled": DashboardSettled,
        "dashboard-pipeline": DashboardPipeline,
        "dashboard-monthly-leads": DashboardMonthlyLeads,
        "dashboard-lead-to-settlement": DashboardLeadToSettlement,
        "date-range-picker": DateRangePicker,
        "multiselect": Multiselect
    },
    data() {
        return {
            dateRange: {
                startDate: this.$moment().startOf('month'),
                endDate: this.$moment().endOf('month'),
            },
            brokerId: null,
            brokerUsers: [],
            teamId: null,
            isLoading: true,
            metrics: {
                settled_deals: 0,
                naf: 0,
                commissions_earned: 0,
                insurance_deals: 0,
                insurance_commissions_earned: 0,
                tweened_settled_deals: 0,
                tweened_naf: 0,
                tweened_commissions_earned: 0,
                tweened_insurance_deals: 0,
                tweened_insurance_commissions_earned: 0,
                tweened_lead_to_app_conversion: 0,
                tweened_closed_apps: 0,
                lead_to_app_conversion: 0,
                closed_apps: 0
            },
            monthLabels: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            columns: {
                1: [
                    [
                        'dashboard-widget-filter',
                        'funnel-container',
                        'dashboard-lead-to-settle',
                        'dashboard-team-leaderboards',
                        'dashboard-leaderboard',
                        'dashboard-lender-submissions',
                        'dashboard-lender-leaderboards',
                        'dashboard-avg-income',
                        'dashboard-total-income'
                    ]
                ],
                2: [
                    [
                        'dashboard-widget-filter',
                        'dashboard-leaderboard',
                        'dashboard-lender-leaderboards',
                        'funnel-container',
                        'dashboard-total-income',
                        'dashboard-lender-submissions'
                    ], [
                        'dashboard-lead-to-settle',
                        'dashboard-team-leaderboards',
                        'dashboard-avg-income'
                    ]
                ],
                3: [
                    [
                        'dashboard-widget-filter',
                        'dashboard-lender-leaderboards'
                    ], [
                        'funnel-container',
                        'dashboard-avg-income',
                    ], [
                        'dashboard-lead-to-settle',
                        'dashboard-total-income'
                    ]
                ],
                4: [
                    [
                        'dashboard-widget-filter',
                        'dashboard-leaderboard'
                    ], [
                        'funnel-container',
                        'dashboard-lender-leaderboards',
                        'dashboard-lender-submissions'
                    ], [
                        'dashboard-lead-to-settle',
                        'dashboard-avg-income',
                        'dashboard-total-income'
                    ], [
                        'dashboard-team-leaderboards'
                    ]
                ]
            },
            windowSize: 0,
            btnDisable: false
        };
    },
    methods: {
        handleActionButtonClick(e) {
            e.stopPropagation()
        },
        clearModelCache() {
            this.$admin.get(`/api/actions/clear-cache`)
            .then(res => {
            }).catch(err => {

            });
        },

        addLibertyProducts() {
            this.$admin.get(`/api/actions/add-liberty-products`)
            .then(res => {
            }).catch(err => {

            });
        },

        updateLibertyProducts() {
            this.$admin.get(`/api/actions/generate-tenant-tokens`)
            .then(res => {
            }).catch(err => {

            });
        },

        teamIdWatcher() {
            this.getBrokersList();
            this.getMonthToDateStats();
        },
        refreshData: function () {
            this.btnDisable = true
            this.getMonthToDateStats()
            this.$bus.$emit("refreshed-data", true)

            this.btnDisable = false
        },
        getBrokersList() {
            this.isLoading = true;

            this.$admin.get(`/api/v2/brokers`, {
                teamId: this.teamId
            }).then(res => this.brokerUsers = res.data)
                .catch(err => console.log)
                .finally(() => this.isLoading = false);

        },
        getMonthToDateStats() {
            this.$admin.post(`/api/v2/metrics`, {
                startDate: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
            }).then(res => {
                Object.assign(this.metrics, res.data)
                this.btnDisable = false
            }).catch(err => {
                console.log('getMonthToDateStats', err)
                this.btnDisable = false
            });
        },
        organiseWidgets() {
            let columnCount = this.dashboardColumns;

            this.columns[columnCount].forEach((col, colIndex) => {
                col.forEach(widgetId => {
                    let widgetEl = $('#' + widgetId).length ? $('#' + widgetId)[0] : null;
                    if (widgetEl) {
                        $('#marker-dashboard-page .cols-' + columnCount + ' .column-' + (colIndex + 1))[0].appendChild($('#' + widgetId)[0]);
                    }
                });
            });

        },
    },
    watch: {
        "metrics.settled_deals": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_settled_deals: newValue
            });
        },
        "metrics.naf": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_naf: newValue
            });
        },
        "metrics.commissions_earned": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_commissions_earned: newValue
            });
        },
        "metrics.insurance_deals": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_insurance_deals: newValue
            });
        },
        "metrics.insurance_commissions_earned": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_insurance_commissions_earned: newValue
            });
        },
        "metrics.lead_to_app_conversion": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_lead_to_app_conversion: newValue
            });
        },
        "metrics.closed_apps": function (newValue) {
            TweenLite.TweenLite.to(this.$data.metrics, 0.75, {
                tweened_closed_apps: newValue
            });
        },
        // migrate this
        brokerId: {
            handler(newVal, oldVal) {
                this.getMonthToDateStats();
            },
            deep: true
        },
        // migrate this
        dateRange: {
            handler(newVal, oldVal) {
                this.getMonthToDateStats();
            },
            deep: true
        },
        windowSize: {
            handler(newVal, oldVal) {
                this.organiseWidgets();
            }
        }
    },
    computed: {
        animatedSettledDeals: function () {
            return Number(Number(this.metrics.tweened_settled_deals).toFixed(0)).toLocaleString("en-AU");
        },
        animatedNAF: function () {
            return Number(Number(this.metrics.tweened_naf).toFixed(0)).toLocaleString("en-AU");
        },
        animatedCommissions: function () {
            return Number(Number(this.metrics.tweened_commissions_earned).toFixed(0)).toLocaleString("en-AU");
        },
        animatedLeadToApp: function () {
            return this.metrics.tweened_lead_to_app_conversion.toFixed(2);
        },
        animatedLeadToApp: function () {
            return this.metrics.tweened_lead_to_app_conversion.toFixed(2);
        },
        animatedInsuranceOnlyDeals: function () {
            return Number(Number(this.metrics.tweened_insurance_deals).toFixed(0)).toLocaleString("en-AU");
        },
        animatedInsuranceOnlyCommissions: function () {
            return Number(Number(this.metrics.tweened_insurance_commissions_earned).toFixed(0)).toLocaleString("en-AU");
        },
        animatedClosedApps: function () {
            return this.metrics.tweened_closed_apps.toFixed(0);
        },
        getTeamId() {
            return this.teamId;
        },
        getUserTeams() {
            return _.get(Ambition, 'Globals.tenant.user.teams', []);
        },
        getBrokerId() {
            return this.brokerId ? this.brokerId.id : null;
        },
        dashboardColumns() {
            if (this.windowSize >= 1980) {
                return 3;
            } else if (this.windowSize >= 1350) {
                return 3;
            } else if (this.windowSize >= 1000) {
                return 2;
            } else {
                return 1;
            }
        }
    },
    created() {
        this.windowSize = window.innerWidth;
        window.addEventListener('resize', () => {
            this.windowSize = window.innerWidth;
        });
        this.teamId = _.get(Ambition, 'Globals.tenant.user.current_team_id');
    },
    mounted() {

        this.$watch('teamId', this.teamIdWatcher);

        // this.getBrokersList();
        // migrate this
        this.getMonthToDateStats();
        // this.refreshData();
    }
};
</script>

<style>

.admin-container {
    padding-top: 50px !important;
}

.mix-blend-mode-multiple {
    mix-blend-mode: multiply;
    will-change: opacity;
}

.mix-blend-mode-multiple img {
    transform: translateZ(0);
    image-rendering: optimize-contrast;
}

#marker-dashboard-page .card {
    background: #ffffffd9;
    border-radius: 0;
}

#marker-dashboard-page .cols-container > div {
    padding-left: 7.5px;
    padding-right: 7.5px;
}

#marker-dashboard-page .el-loading-mask {
    z-index: 1;
}

.dashboard-section .form-group {
    padding: 0;
}

.dashboard-section .vue-daterange-picker .reportrange-text div {
    font-size: 14px;
    line-height: 26px;
}

.dashboard-section .form-control.reportrange-text {
    border-radius: 0;
}

.dashboard-section .el-select input.el-input__inner {
    border-color: #C0C4CC;
    border-radius: 0;
}

.month-year-display .display-text {
    white-space: nowrap;
}

.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel .svg-funnel-js__subLabel--color {
    float: left;
    margin: 1px 4px 1px 4px;
}

.svg-funnel-js .svg-funnel-js__subLabels {
    padding: 15px 15px 0px 15px;
    display: block;
    position: relative;
    margin-top: -20px;
    background: white;
    height: 50px;
}

.svg-funnel-js:not(.svg-funnel-js--vertical) {
    margin-left: -7px;
    margin-bottom: 5px;
}

.admin-dashboard-container .svg-funnel-js:not(.svg-funnel-js--vertical) {
    margin-left: -14px;
}

.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
    float: left;
}

.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
    padding-left: 1px;
    margin-left: 0;
    padding-top: 1px;
}

.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel:not(:first-child) {
    margin-left: 0;
}

#dashboard-widget-filter .form-group[name=picker] {
    padding: 0;
}

#dashboard-widget-filter .form-group[name=picker] .reportrange-text {
    padding: 0;
    height: auto;
    border: none;
    text-align: right;
    font-size: 13px;
    line-height: 23px;
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
    #marker-dashboard-page .card-columns {
        column-count: 1;
    }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
    #marker-dashboard-page .card-columns {
        column-count: 2;
    }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1300px) {
    #marker-dashboard-page .card-columns {
        column-count: 3;
    }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 2000px) {
    #marker-dashboard-page .card-columns {
        column-count: 4;
    }
}

</style>
